import { FormControl } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { SelectValue } from "@radix-ui/react-select";
import { forwardRef, useEffect, useState } from "react";
import { ControllerRenderProps, useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface EnumSelectProps extends ControllerRenderProps {
  options: readonly string[];
  translationKey: string;
  placeholder?: string;
  disabled?: boolean;
}

export default forwardRef<HTMLButtonElement, EnumSelectProps>(
  function EnumSelect(
    {
      onChange,
      value,
      options,
      translationKey,
      placeholder,
      disabled: disabledFromProps,
    },
    ref,
  ) {
    const { t } = useTranslation();
    const { isSubmitting, disabled: formDisabled } = useFormState();
    const [selectedValue, setSelectedValue] = useState(value);

    useEffect(() => {
      setSelectedValue(value);
    }, [value]);

    return (
      <Select
        onValueChange={onChange}
        value={selectedValue}
        disabled={isSubmitting || disabledFromProps || formDisabled}
      >
        <FormControl>
          <SelectTrigger ref={ref} className={cn(!value && "text-slate-500")}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {options.map((type) => (
            <SelectItem value={type} key={type}>
              {t(`${translationKey}.${type}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
